"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PremiumCompanyProfileComparisonTable = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const elements_1 = require("@src/components/elements");
const react_1 = __importDefault(require("react"));
const react_intl_1 = require("react-intl");
const styled_components_1 = __importDefault(require("styled-components"));
const icons_1 = require("@ant-design/icons");
const streamline_icon_diamond_money_payments_finance_svg_1 = __importDefault(require("@public/media/icons/streamline-icon-diamond-money-payments-finance.svg"));
const polished_1 = require("polished");
const react_router_1 = require("react-router");
const account_context_1 = require("@src/context/account-context");
const premium_company_profile_modal_context_1 = require("@src/context/premium-company-profile-modal-context");
const react_styled_1 = require("styled-breakpoints/react-styled");
const styled_breakpoints_1 = require("styled-breakpoints");
const PremiumCompanyProfileComparisonTable = () => {
    const intl = (0, react_intl_1.useIntl)();
    const history = (0, react_router_1.useHistory)();
    const [profileFeaturesTableRef, setProfileFeaturesTableRef] = react_1.default.useState(null);
    const location = (0, react_router_1.useLocation)();
    const account = (0, account_context_1.useAccount)();
    const { setIsPremiumCompanyProfileSubscriptionModalOpen } = (0, premium_company_profile_modal_context_1.usePremiumCompanyProfileModalContextValue)();
    const isSmOrLowerLayout = (0, react_styled_1.useBreakpoint)((0, styled_breakpoints_1.down)('sm'));
    const paymentsTableScroll = isSmOrLowerLayout ? { x: 400 } : undefined;
    react_1.default.useEffect(() => {
        if (location.hash === '#features' && profileFeaturesTableRef) {
            profileFeaturesTableRef.scrollIntoView({ behavior: 'smooth' });
        }
    }, [profileFeaturesTableRef, location]);
    const columns = react_1.default.useMemo(() => [
        {
            dataIndex: 'name',
            key: 'name',
            width: '40%',
            render: (value) => {
                return (0, jsx_runtime_1.jsx)(FeatureName, { children: value });
            },
        },
        {
            title: ((0, jsx_runtime_1.jsx)(BasicProfileHeader, { children: (0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "company_premium_profile.free_profile" }) })),
            dataIndex: 'availableForFreeProfile',
            key: 'availableForFreeProfile',
            align: 'center',
            width: '30%',
            render: (_, { isActionButton, availableForFreeProfile, }) => {
                if (isActionButton) {
                    if (!account || !(account === null || account === void 0 ? void 0 : account.companyId)) {
                        return ((0, jsx_runtime_1.jsx)(ColumnButton, { type: "secondary", shape: "round", link: account ? '/registracia-prihlaseny-pouzivatel' : '/registracia', children: (0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "company_premium_profile.try_for_free" }) }));
                    }
                    return null;
                }
                return availableForFreeProfile ? (0, jsx_runtime_1.jsx)(StyledCheckmark, {}) : (0, jsx_runtime_1.jsx)(StyledX, {});
            },
        },
        {
            title: ((0, jsx_runtime_1.jsxs)(PremiumProfileHeader, { children: [(0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "company_premium_profile.premium_profile" }), (0, jsx_runtime_1.jsx)(PremiumIconWrapper, { children: (0, jsx_runtime_1.jsx)(streamline_icon_diamond_money_payments_finance_svg_1.default, { width: 14, height: 14 }) })] })),
            dataIndex: ['availableForPremiumProfile', 'isActionButton'],
            key: 'availableForPremiumProfile',
            align: 'center',
            width: '30%',
            render: (_, { isActionButton, availableForPremiumProfile, }) => {
                if (isActionButton) {
                    if (!account || !(account === null || account === void 0 ? void 0 : account.companyId)) {
                        return ((0, jsx_runtime_1.jsx)(ColumnButton, { type: "primary", shape: "round", link: account ? '/registracia-prihlaseny-pouzivatel' : '/registracia', children: (0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "general.registration_company" }) }));
                    }
                    return ((0, jsx_runtime_1.jsx)(ColumnButton, { type: "primary", shape: "round", onClick: () => setIsPremiumCompanyProfileSubscriptionModalOpen(true), children: (0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "company_premium_profile.buy_subscription" }) }));
                }
                return availableForPremiumProfile ? (0, jsx_runtime_1.jsx)(StyledCheckmark, {}) : (0, jsx_runtime_1.jsx)(StyledX, {});
            },
        },
    ], [history]);
    const data = react_1.default.useMemo(() => [
        {
            key: '1',
            name: intl.formatMessage({ id: 'company_premium_profile.features.unlimited_company_users' }),
            availableForFreeProfile: true,
            availableForPremiumProfile: true,
        },
        {
            key: '2',
            name: intl.formatMessage({ id: 'company_premium_profile.features.candidate_management' }),
            availableForFreeProfile: true,
            availableForPremiumProfile: true,
        },
        {
            key: '3',
            name: intl.formatMessage({ id: 'company_premium_profile.features.online_video_interviews' }),
            availableForFreeProfile: true,
            availableForPremiumProfile: true,
        },
        {
            key: '4',
            name: intl.formatMessage({ id: 'company_premium_profile.features.public_company_profile' }),
            availableForFreeProfile: true,
            availableForPremiumProfile: true,
        },
        {
            key: '5',
            name: intl.formatMessage({ id: 'company_premium_profile.features.analytics' }),
            availableForFreeProfile: false,
            availableForPremiumProfile: true,
        },
        {
            key: '6',
            name: intl.formatMessage({ id: 'company_premium_profile.features.photos_and_videos_offer' }),
            availableForFreeProfile: false,
            availableForPremiumProfile: true,
        },
        {
            key: '7',
            name: intl.formatMessage({ id: 'company_premium_profile.features.photos_and_videos_public_profile' }),
            availableForFreeProfile: false,
            availableForPremiumProfile: true,
        },
        {
            key: '8',
            name: intl.formatMessage({ id: 'company_premium_profile.features.highlighting_company_profile' }),
            availableForFreeProfile: false,
            availableForPremiumProfile: true,
        },
        {
            key: '9',
            name: intl.formatMessage({ id: 'company_premium_profile.features.main_page_company_logo' }),
            availableForFreeProfile: false,
            availableForPremiumProfile: true,
        },
        {
            key: '10',
            isActionButton: true,
        },
    ], [intl]);
    return ((0, jsx_runtime_1.jsx)("div", { ref: ref => setProfileFeaturesTableRef(ref), className: "m-b-xl m-t-xl", children: (0, jsx_runtime_1.jsx)(StyledTable, { pagination: false, columns: columns, dataSource: data, scroll: paymentsTableScroll }) }));
};
exports.PremiumCompanyProfileComparisonTable = PremiumCompanyProfileComparisonTable;
const PremiumIconWrapper = styled_components_1.default.div `
	margin-left: 0.5rem;
	background: ${({ theme }) => (0, polished_1.transparentize)(0.8, theme.color.gold)};
	width: 1.5rem;
	height: 1.5rem;
	max-width: 1.5rem;
	max-height: 1.5rem;
	min-width: 1.5rem;
	min-height: 1.5rem;
	display: flex;
	align-items: center;
	justify-content: center;
	border: 1px solid ${({ theme }) => theme.color.gold};
	border-radius: 1rem;
	color: ${({ theme }) => theme.color.gold};
`;
const StyledTable = (0, styled_components_1.default)(elements_1.Table) `
	thead > tr > th:last-child {
		background-color: ${({ theme }) => theme.color.brandDarkBlue};
	}
	,
	thead > tr > th {
		background-color: ${({ theme }) => theme.color.gray3};
	}
`;
const StyledCheckmark = (0, styled_components_1.default)(icons_1.CheckOutlined) `
	color: ${({ theme }) => theme.color.success};
	padding: 0.5rem;
	border-radius: 1rem;
	background: ${({ theme }) => (0, polished_1.transparentize)(0.9, theme.color.success)};
`;
const StyledX = (0, styled_components_1.default)(icons_1.CloseOutlined) `
	color: ${({ theme }) => theme.color.error};
	padding: 0.5rem;
	border-radius: 1rem;
	background: ${({ theme }) => (0, polished_1.transparentize)(0.9, theme.color.error)};
`;
const FeatureName = styled_components_1.default.div `
	font-size: 1rem;
`;
const BasicProfileHeader = styled_components_1.default.div `
	color: ${({ theme }) => theme.color.black};
`;
const PremiumProfileHeader = styled_components_1.default.div `
	color: ${({ theme }) => theme.color.white};
	display: flex;
	align-items: center;
	justify-content: center;
`;
const ColumnButton = (0, styled_components_1.default)(elements_1.Button) `
	white-space: normal;
	word-break: keep-all;
	&& {
		height: auto;
	}
`;
